import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/Alarm/Schedule/SuccessBox';
import SheduleTable from 'components/Web_User_Interface/1080p_Series/Alarm/Schedule/scheduleTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  SheduleTable,
  BreadCrumbs,
  SEOHelmet,
  React
};